// data.jsx — mock domain data, article register, templates, formatters
// Swedish UI, SEK, km. Exported to window.

// ── Formatters ──────────────────────────────────────────────
const nf0 = new Intl.NumberFormat('sv-SE', { maximumFractionDigits: 0 });
const nf1 = new Intl.NumberFormat('sv-SE', { minimumFractionDigits: 0, maximumFractionDigits: 1 });

function kr(n) { return nf0.format(Math.round(n || 0)) + ' kr'; }
function num(n, d = 1) { return (d === 0 ? nf0 : nf1).format(n || 0); }
function fmtMin(m) {
  m = Math.round(m || 0);
  const h = Math.floor(m / 60), mm = m % 60;
  if (h && mm) return `${h} tim ${mm} min`;
  if (h) return `${h} tim`;
  return `${mm} min`;
}
function fmtHM(m) { // compact 1:30
  const h = Math.floor(m / 60), mm = m % 60;
  return `${h}:${String(mm).padStart(2, '0')}`;
}

// ── Status meta ─────────────────────────────────────────────
const STATUS = {
  planerad:    { key: 'planerad',    label: 'Planerad',    color: '#3f6ea3', wash: '#e9f0f7' },
  rapporterad: { key: 'rapporterad', label: 'Rapporterad', color: '#b07d1a', wash: '#f6ecd5' },
  fakturerad:  { key: 'fakturerad',  label: 'Fakturerad',  color: '#5b9a6b', wash: '#e8f1ea' },
};
const STATUS_ORDER = ['planerad', 'rapporterad', 'fakturerad'];

// ── Article register (price book) ──────────────────────────
// kind: time (qty in tim), distance (km), material (à-pris user-set), cost (per unit)
const ARTICLES = [
  { code: 'ARB',    name: 'Arbetstid',         unit: 'tim',  rate: 695, kind: 'time',     icon: 'wrench' },
  { code: 'RES',    name: 'Restid',            unit: 'tim',  rate: 475, kind: 'time',     icon: 'route' },
  { code: 'KM',     name: 'Reskostnad',        unit: 'km',   rate: 38,  kind: 'distance', icon: 'car' },
  { code: 'MTRL',   name: 'Material',          unit: 'st',   rate: 0,   kind: 'material', icon: 'box' },
  { code: 'HOTEL',  name: 'Hotell / logi',     unit: 'natt', rate: 1290,kind: 'cost',     icon: 'bed' },
  { code: 'TRAKT',  name: 'Traktamente',       unit: 'dygn', rate: 290, kind: 'cost',     icon: 'sun' },
  { code: 'UTRUST', name: 'Hyrd utrustning',   unit: 'dygn', rate: 450, kind: 'cost',     icon: 'tool' },
];
const artByCode = (c) => ARTICLES.find(a => a.code === c);

// ── Report templates (a report = multiple rows) ─────────────
const TEMPLATES = [
  { id: 't_arbete',   name: 'Endast arbete',     desc: 'Arbetstid',                       rows: ['ARB'] },
  { id: 't_service',  name: 'Servicebesök',      desc: 'Arbete · restid · km',            rows: ['ARB', 'RES', 'KM'] },
  { id: 't_material', name: 'Arbete + material', desc: 'Arbete · restid · km · material', rows: ['ARB', 'RES', 'KM', 'MTRL'] },
  { id: 't_resande',  name: 'Resande montör',    desc: 'Arbete · restid · km · hotell · traktamente', rows: ['ARB', 'RES', 'KM', 'HOTEL', 'TRAKT'] },
];

// ── Jobs (today = 2026-06-15) ───────────────────────────────
// coords are normalized 0..1 positions used only to place the pin on the map mock.
let _seq = 1;
const uid = (p = 'r') => `${p}${_seq++}`;

const JOBS = [
  {
    id: 'U-1042', title: 'Byte av varmvattenberedare', customer: 'Familjen Andersson',
    status: 'planerad', date: '2026-06-15', startTime: '08:30', estMinutes: 120,
    address: 'Storgatan 14, 411 24 Göteborg', pin: { x: 0.42, y: 0.38 },
    fromAddress: 'Verkstaden · Ringön 6', travelMinutes: 18, travelKm: 9.4,
    description: 'Befintlig beredare läcker. Demontera och installera ny 300 l beredare. Kontrollera anslutningar och säkerhetsventil.',
    materials: [
      { name: 'Varmvattenberedare 300 l', qty: 1, unit: 'st' },
      { name: 'Kopplingssats', qty: 1, unit: 'st' },
      { name: 'Säkerhetsventil', qty: 1, unit: 'st' },
    ],
    report: null,
  },
  {
    id: 'U-1043', title: 'Felsökning värmepump', customer: 'Ekströms Fastigheter AB',
    status: 'planerad', date: '2026-06-15', startTime: '11:00', estMinutes: 90,
    address: 'Lundbygatan 3, 417 06 Göteborg', pin: { x: 0.30, y: 0.30 },
    fromAddress: 'Storgatan 14, Göteborg', travelMinutes: 14, travelKm: 6.1,
    description: 'Värmepump larmar intermittent. Felsöka, läsa av loggar och åtgärda.',
    materials: [],
    report: null,
  },
  {
    id: 'U-1044', title: 'Montering laddbox', customer: 'BRF Solrosen',
    status: 'planerad', date: '2026-06-15', startTime: '14:00', estMinutes: 150,
    address: 'Frölundagatan 22, 431 44 Mölndal', pin: { x: 0.55, y: 0.66 },
    fromAddress: 'Lundbygatan 3, Göteborg', travelMinutes: 26, travelKm: 17.8,
    description: 'Installera 11 kW laddbox i garage, dra kabel från elcentral och driftsätta.',
    materials: [
      { name: 'Laddbox 11 kW', qty: 1, unit: 'st' },
      { name: 'Kabel EQLQ 5G6', qty: 25, unit: 'm' },
    ],
    report: null,
  },
  {
    id: 'U-1045', title: 'Byte av köksblandare', customer: 'Familjen Holm',
    status: 'planerad', date: '2026-06-16', startTime: '08:00', estMinutes: 90,
    address: 'Nordstan 5, 411 05 Göteborg', pin: { x: 0.46, y: 0.42 },
    fromAddress: 'Verkstaden · Ringön 6', travelMinutes: 11, travelKm: 4.6,
    description: 'Byte av läckande köksblandare samt kontroll av vattenlås under diskbänk.',
    materials: [{ name: 'Köksblandare', qty: 1, unit: 'st' }],
    report: null,
  },
  {
    id: 'U-1046', title: 'Service frånluftsvärmepump', customer: 'BRF Kajutan',
    status: 'planerad', date: '2026-06-16', startTime: '11:30', estMinutes: 120,
    address: 'Kvilletorget 2, 417 04 Göteborg', pin: { x: 0.34, y: 0.36 },
    fromAddress: 'Nordstan 5, Göteborg', travelMinutes: 13, travelKm: 5.9,
    description: 'Årlig service och filterbyte på frånluftsvärmepump i flerbostadshus.',
    materials: [{ name: 'Filtersats', qty: 1, unit: 'st' }],
    report: null,
  },
  {
    id: 'U-1047', title: 'Installation tvättmaskin', customer: 'Villa Ek',
    status: 'planerad', date: '2026-06-17', startTime: '09:30', estMinutes: 75,
    address: 'Hagagatan 7, 413 01 Göteborg', pin: { x: 0.5, y: 0.55 },
    fromAddress: 'Verkstaden · Ringön 6', travelMinutes: 15, travelKm: 7.2,
    description: 'Installation och inkoppling av ny tvättmaskin samt provkörning.',
    materials: [],
    report: null,
  },
  {
    id: 'U-1039', title: 'Service ventilationsaggregat', customer: 'Café Bryggan',
    status: 'planerad', date: '2026-06-15', startTime: '07:15', estMinutes: 75,
    address: 'Kajvägen 8, 414 58 Göteborg', pin: { x: 0.48, y: 0.5 },
    fromAddress: 'Verkstaden · Ringön 6', travelMinutes: 12, travelKm: 5.2,
    description: 'Periodisk service: byte av filter, rengöring och funktionskontroll.',
    materials: [{ name: 'Filtersats F7', qty: 2, unit: 'st' }],
    report: null,
  },
  {
    id: 'U-1031', title: 'Reparation diskmaskin', customer: 'Restaurang Kajen',
    status: 'rapporterad', date: '2026-06-12', startTime: '09:00', estMinutes: 60,
    address: 'Hamngatan 2, 411 06 Göteborg', pin: { x: 0.4, y: 0.45 },
    fromAddress: 'Verkstaden · Ringön 6', travelMinutes: 16, travelKm: 8.0,
    description: 'Industridiskmaskin spolar inte. Byte av spolarmsmotor.',
    materials: [{ name: 'Spolarmsmotor', qty: 1, unit: 'st' }],
    report: { photos: ['p'], notes: 'Bytte motor, testkört OK.', rows: [
      { id: 'a', code: 'ARB', qty: 1.5, note: '' },
      { id: 'b', code: 'RES', qty: 0.5, note: '' },
      { id: 'c', code: 'KM', qty: 16, note: 'T/R' },
      { id: 'd', code: 'MTRL', qty: 1, rate: 2450, label: 'Spolarmsmotor', note: '' },
    ] },
  },
  {
    id: 'U-1028', title: 'Installation utomhusbelysning', customer: 'Villa Lindqvist',
    status: 'rapporterad', date: '2026-06-11', startTime: '13:00', estMinutes: 180,
    address: 'Ekvägen 11, 436 33 Askim', pin: { x: 0.6, y: 0.72 },
    fromAddress: 'Verkstaden · Ringön 6', travelMinutes: 24, travelKm: 15.5,
    description: 'Markförläggning och montage av 6 pollare längs uppfart.',
    materials: [{ name: 'Pollare 0,8 m', qty: 6, unit: 'st' }, { name: 'Kabel', qty: 40, unit: 'm' }],
    report: { photos: ['p', 'p'], notes: '', rows: [
      { id: 'a', code: 'ARB', qty: 4, note: '' },
      { id: 'b', code: 'RES', qty: 1, note: '' },
      { id: 'c', code: 'KM', qty: 31, note: '' },
      { id: 'd', code: 'MTRL', qty: 6, rate: 1190, label: 'Pollare 0,8 m', note: '' },
    ] },
  },
  {
    id: 'U-1021', title: 'Akut vattenläcka', customer: 'Kontorshuset Lilla Bommen',
    status: 'fakturerad', date: '2026-06-05', startTime: '16:40', estMinutes: 90,
    address: 'Lilla Bommen 1, 411 04 Göteborg', pin: { x: 0.45, y: 0.4 },
    fromAddress: 'Verkstaden · Ringön 6', travelMinutes: 10, travelKm: 4.1,
    description: 'Akut läckage i undercentral. Tätning och provtryckning.',
    materials: [], invoiceNo: 'F-2451', invoicedAt: '2026-06-06',
    report: { photos: ['p'], notes: '', rows: [
      { id: 'a', code: 'ARB', qty: 2, note: 'Akut, kväll' },
      { id: 'b', code: 'RES', qty: 0.5, note: '' },
      { id: 'c', code: 'KM', qty: 8, note: '' },
    ] },
  },
  {
    id: 'U-1015', title: 'Byte säkringsskåp', customer: 'Familjen Berg',
    status: 'fakturerad', date: '2026-06-02', startTime: '08:00', estMinutes: 240,
    address: 'Björkgatan 5, 412 55 Göteborg', pin: { x: 0.35, y: 0.55 },
    fromAddress: 'Verkstaden · Ringön 6', travelMinutes: 19, travelKm: 10.2,
    description: 'Byte av gammal proppcentral till modern automatsäkringscentral.',
    materials: [], invoiceNo: 'F-2447', invoicedAt: '2026-06-03',
    report: { photos: ['p', 'p', 'p'], notes: '', rows: [
      { id: 'a', code: 'ARB', qty: 5, note: '' },
      { id: 'b', code: 'MTRL', qty: 1, rate: 4290, label: 'Normcentral 2-rad', note: '' },
    ] },
  },
];

// ── Derived helpers ─────────────────────────────────────────
let VAT = 0.25;
function rowAmount(row) {
  const a = artByCode(row.code);
  const rate = row.rate != null ? row.rate : (a ? a.rate : 0);
  return (row.qty || 0) * (rate || 0);
}
function reportTotal(report) {
  if (!report || !report.rows) return 0;
  return report.rows.reduce((s, r) => s + rowAmount(r), 0);
}
function rowLabel(row) {
  if (row.label) return row.label;
  const a = artByCode(row.code);
  return a ? a.name : row.code;
}
function rowUnit(row) {
  const a = artByCode(row.code);
  return a ? a.unit : '';
}
function rowRate(row) {
  const a = artByCode(row.code);
  return row.rate != null ? row.rate : (a ? a.rate : 0);
}

// ── Scheduling helpers (lunch, groups, travel) ──────────
const WORK_START_MIN = 7 * 60;   // 07:00
const WORK_END_MIN = 16 * 60;    // 16:00
function hmToMin(t) { const m = /^(\d{1,2}):(\d{2})$/.exec((t || '').trim()); if (!m) return null; const h = +m[1], mm = +m[2]; return (h > 23 || mm > 59) ? null : h * 60 + mm; }
function minToHM(n) { n = ((Math.round(n) % 1440) + 1440) % 1440; return `${String(Math.floor(n / 60)).padStart(2, '0')}:${String(n % 60).padStart(2, '0')}`; }
// round a minute-of-day UP to the next `step`-minute grid (planned times land on :00/:15/:30/:45)
function ceilMin(n, step = 15) { return Math.ceil(n / step) * step; }
function lunchWindow(settings) { if (!settings || !settings.lunchOn) return null; const ls = hmToMin(settings.lunchStart || '12:00'); if (ls == null) return null; const len = settings.lunchMinutes || 30; return { s: ls, e: ls + len, len }; }
// minutes of lunch a work block [start, start+dur] runs through (0 if it doesn't cross lunch)
function lunchAbsorb(startMin, durMin, settings) { const lw = lunchWindow(settings); if (!lw) return 0; return (startMin < lw.e && lw.s < startMin + durMin) ? lw.len : 0; }
// all jobs in a split-mission group, in chronological order
function groupParts(jobs, groupId) { if (!groupId) return []; return jobs.filter(j => j.groupId === groupId).sort((a, b) => (a.date + a.startTime).localeCompare(b.date + b.startTime)); }
function nextGroupId(jobs) { const max = jobs.reduce((m, j) => { if (!j.groupId) return m; const n = parseInt((j.groupId.split('-')[1]) || 0, 10); return Math.max(m, n); }, 100); return 'G-' + (max + 1); }

// Mock "Google Maps" travel between two map pins (normalized 0..1 over ~25 km area).
function travelBetween(a, b) {
  if (!a || !b) return { km: 0, min: 0 };
  const dx = (a.x - b.x), dy = (a.y - b.y);
  const km = Math.round(Math.hypot(dx, dy) * 27 * 10) / 10;
  const min = Math.max(4, Math.round(km * 2.1 + 4));
  return { km, min };
}
// The scheduled job that ends most recently before this one, same day (its actual predecessor).
function prevJobSameDay(job, jobs) {
  const s = hmToMin(job.startTime); if (s == null) return null;
  const end = (j) => hmToMin(j.startTime) + (j.estMinutes || 0);
  return jobs
    .filter(j => j.id !== job.id && j.date === job.date && j.startTime && hmToMin(j.startTime) != null && end(j) <= s)
    .sort((a, b) => end(b) - end(a))[0] || null;
}
// Resolve where the technician departs FROM for a job, and the resulting travel.
// mode 'auto' = previous scheduled job that day, else the workshop.
function resolveDeparture(job, jobs = []) {
  const mode = job.fromMode || (job.fromAddress ? 'fixed' : 'auto');
  if (mode === 'gps') return { basis: 'gps', label: 'Min plats (GPS)', address: 'GPS', min: job.travelMinutes || 0, km: job.travelKm || 0, resolved: true };
  if (mode === 'workshop' || mode === 'fixed') return { basis: 'workshop', label: job.fromAddress || COMPANY.base, address: COMPANY.base, min: job.travelMinutes || 0, km: job.travelKm || 0, resolved: true };
  // auto
  const prev = prevJobSameDay(job, jobs);
  if (prev) { const t = travelBetween(prev.pin, job.pin); return { basis: 'previous', label: prev.title, address: prev.address, min: t.min, km: t.km, prev, resolved: true }; }
  return { basis: 'workshop', label: COMPANY.base, address: COMPANY.base, min: job.travelMinutes || 0, km: job.travelKm || 0, resolved: true };
}

// Real "today" (local date, YYYY-MM-DD). The prototype pinned this to a fixed date to
// line up with demo data; a live app must use the actual current day.
const TODAY = (() => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
})();
function isoLocal(d) {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}
function fmtDateLong(iso) {
  const d = new Date(iso + 'T00:00:00');
  const s = d.toLocaleDateString('sv-SE', { weekday: 'long', day: 'numeric', month: 'long' });
  return s.charAt(0).toUpperCase() + s.slice(1);
}
function fmtDateShort(iso) {
  const d = new Date(iso + 'T00:00:00');
  if (iso === TODAY) return 'Idag';
  return d.toLocaleDateString('sv-SE', { day: 'numeric', month: 'short' });
}

const APP = {
  name: 'Giant Valley Job Manager',
  short: 'Giant Valley',
  tagline: 'Planera · Utför · Fakturera',
};
const COMPANY = {
  name: 'Lindberg Service & VVS',
  user: 'Marcus Lindberg',
  role: 'Servicetekniker',
  base: 'Verkstaden · Ringön 6, Göteborg',
};

// Mutators so the app can swap in the user's saved settings at runtime. The screens read
// these module singletons directly, so we keep the SAME references and mutate in place.
function setArticles(list) { if (Array.isArray(list) && list.length) { ARTICLES.length = 0; list.forEach((a) => ARTICLES.push(a)); } }
function setCompany(patch) { if (patch && typeof patch === 'object') Object.assign(COMPANY, patch); }
function setVat(v) { const n = Number(v); if (!Number.isNaN(n) && n >= 0) VAT = n; }

export {
  kr, num, fmtMin, fmtHM, STATUS, STATUS_ORDER, ARTICLES, artByCode,
  TEMPLATES, JOBS, VAT, rowAmount, reportTotal, rowLabel, rowUnit, rowRate,
  TODAY, isoLocal, fmtDateLong, fmtDateShort, APP, COMPANY, uid,
  WORK_START_MIN, WORK_END_MIN, hmToMin, minToHM, ceilMin, lunchWindow, lunchAbsorb, groupParts, nextGroupId,
  travelBetween, prevJobSameDay, resolveDeparture,
  setArticles, setCompany, setVat,
};
